package it.neckar.lizergy.model

interface OverridablePosition<T> {
  val position: T
  val override: T?

  val value: T
    get() = override ?: position
}
